import CSV_ICON from "Content/images/fileIcon/csv.svg";
import { FileUploader } from "devextreme-react";
import includes from "lodash/includes";
import styled from "styled-components";
export const SIZES = {
    UPLOAD_CLOSE: {
        SIZE: 14,
        SIZE_FONT: 10
    },
    UPLOAD_BUTTON_WIDTH: 250,
    ERROR_CONTAINER_HEIGHT: 40,
    ERROR_CONTAINER_LINE_HEIGHT: 22,
    IMPORT_MODAL_WIDTH: 700,
    IMPORT_MODAL_HEIGHT: 640
};
let canvas;
export const getTextWidth = (text, fontFamily, fontSize) => {
    canvas = canvas || document.createElement("canvas");
    const context = canvas.getContext("2d");
    if (context) {
        context.font = `${fontSize} ${fontFamily}`;
        const metrics = context.measureText(text);
        return metrics.width;
    }
    return Math.ceil(SIZES.UPLOAD_BUTTON_WIDTH * 0.9);
};
export default {
    Container: styled.div.withConfig({
        shouldForwardProp: (prop) => !includes(["hasImportPanel"], prop)
    }) `
    display: grid;
    grid-template-rows: auto auto 1fr ${({ hasImportPanel }) => (hasImportPanel ? "auto" : "")} auto;
  `,
    UploadButton: styled(FileUploader).withConfig({
        shouldForwardProp: (prop) => !includes(["size"], prop)
    }) `
    width: calc(${SIZES.UPLOAD_BUTTON_WIDTH}px - 2em);

    .dx-button-text {
      color: ${({ theme, size }) => theme[size ? "gray-700" : "gray-500"]};
    }

    &:after {
      position: absolute;
      bottom: 0px;
      left: 2em;
      color: ${({ theme }) => theme["gray-500"]};
      font-size: ${({ theme }) => theme["font-size-small"]};
      line-height: ${({ theme }) => theme["line-height-medium"]};
      content: "${props => props.size}";
    }

    .dx-widget {
      background-color: transparent !important;
    }

    .dx-fileuploader-input-wrapper,
    .dx-fileuploader-content > .dx-fileuploader-upload-button {
      display: block;
      padding: 0;
      border: 0;
    }

    .dx-fileuploader-wrapper {
      padding: 0;
    }
    .dx-fileuploader-button {
      padding: 0px 1em 0px 1.5em !important;
      height: 1.75em !important;
      border: none !important;
    }
    &:not(.chosen) .dx-fileuploader-button {
      position: relative;
      &:before {
        content: "\\e946";
        font: ${({ theme }) => theme["icomoon-icons"]};
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    &.chosen .dx-fileuploader-button {
      background-repeat: no-repeat;
      background-image: url(${CSV_ICON}) !important;
    }
    .dx-fileuploader-files-container,
    .dx-fileuploader-input-container {
      display: none;
    }
  `,
    ErrorContainer: styled.div.attrs({ className: "text-danger-500 font-small" }) `
    height: ${SIZES.ERROR_CONTAINER_HEIGHT}px;
    display: flex;
    flex-direction: column;
    line-height: ${SIZES.ERROR_CONTAINER_LINE_HEIGHT}px;
  `
};
